import { defineComponent as _defineComponent } from 'vue'
import {
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch,
  computed
} from 'vue'

import {
  DEFAULT_SORT_COLUMN_FETCH_ISSUERS
} from "@/components/issuers/scripts/constants";

import {
  debounce,
  isAbortError,
} from "@/scripts/Common/HelperFunctions";

import {
  useI18n
} from '@/composables/useI18n';

import {
  Issuer,
} from "@/model/Issuer";

import {
  fetchIssuers,
} from "@/components/issuers/scripts/issuers/requests";

import {
  FetchIssuersParam
} from "@/components/issuers/scripts/issuers/types";

import {
  IssuerCard,
} from "@/components/issuers/scripts/issuerCards";


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateIssuerCards',
  props: {
  selectedCards: {
    default: [],
    type: Array as PropType<IssuerCard[]>
  }
},
  emits: [
  'onDialogCancel',
  'onDialogConfirm',
  'onError',
],
  setup(__props, { emit: emits }) {

const props = __props;



const {
  t
} = useI18n();



const issuers = ref<Issuer[]>([]);
const comboSelection = ref<Issuer | String | undefined>(undefined);
const issuerSearchInput = ref<string | undefined>(undefined);
const isDialogVisible = ref<boolean>(false);

let fetchIssuersAbortController : AbortController = new AbortController();

const isIssuerSelected = computed(() => {
  return comboSelection.value instanceof Issuer;
});

const onHandleDialogCancel = () => {
  emits('onDialogCancel');
};

const onHandleDialogUpdateConfirm = () => {
  emits('onDialogConfirm', {
    issuerId: (comboSelection.value as Issuer).Id
  });
};

const loadIssuers = async () => {

  const fetchArgs: FetchIssuersParam = {
    sortColumn: DEFAULT_SORT_COLUMN_FETCH_ISSUERS
  };

  if (issuerSearchInput.value) fetchArgs.companyName = issuerSearchInput.value;

  fetchIssuersAbortController.abort();
  fetchIssuersAbortController = new AbortController();

  const {response, error} = await fetchIssuers(fetchArgs, fetchIssuersAbortController.signal);

  if(isAbortError(error)) {
    return;
  };

  if (error) {
    onHandleFetchError({error});
    return;
  }

  issuers.value = response ?? [];
}

const onHandleFetchError = ({error}: { error: any }) => {
  emits('onError', {error})
};

watch(issuerSearchInput, debounce(async () => {
  await loadIssuers();
}));

onMounted(() => {
  isDialogVisible.value = true;
});

onUnmounted(() => {
  isDialogVisible.value = false;
})

return { __sfc: true,emits, t, props, issuers, comboSelection, issuerSearchInput, isDialogVisible, fetchIssuersAbortController, isIssuerSelected, onHandleDialogCancel, onHandleDialogUpdateConfirm, loadIssuers, onHandleFetchError }
}

})